<!-- Button -->
<button mat-icon-button [matMenuTriggerFor]="userActions" [matTooltip]="'Mi perfil'" [matTooltipHideDelay]="500"
  [matTooltipPosition]="'above'">
  <span class="relative">
    <mat-icon [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
  </span>
</button>

<mat-menu [xPosition]="'before'" #userActions="matMenu">
  <div class="row text-center">
    <div class="col-12 text-base text-center text-bxBlue">Mi perfil</div>
    <mat-divider class="mb-1"></mat-divider>
  </div>
  
  <button mat-menu-item class="h-8">
    <mat-icon class="icon-size-5 text-green-500" [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
    <span class="text-base font-normal line-clamp-2">
      {{ user?.cliente }}</span>
  </button>

  <button mat-menu-item class="h-16" (click)="$event.stopPropagation()">
    <mat-icon class="icon-size-5 text-green-500" [svgIcon]="'heroicons_outline:hashtag'" [matTooltip]="'Contrato'"
      [matTooltipHideDelay]="500" [matTooltipPosition]="'left'"></mat-icon>
    <mat-form-field class="mt-4" *ngIf="lstContracts?.length >= 2">
      <mat-label>Contratos</mat-label>
      <mat-select [formControl]="contractSession" >
        <mat-option *ngFor="let itmContract of lstContracts" [value]="itmContract" (click)="changeContract(itmContract)">
          {{ itmContract.contrato }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <span class="text-base font-normal" *ngIf="lstContracts?.length ==1 "> {{ user?.contrato }}</span>
  </button>

  <button mat-menu-item class="h-8">
    <mat-icon class="icon-size-5 text-green-500" [svgIcon]="'heroicons_outline:phone'" [matTooltip]="'Teléfono'"
      [matTooltipHideDelay]="500" [matTooltipPosition]="'left'"></mat-icon>
    <span class="text-base font-normal"> {{user?.telefonoCliente}}
    </span>
  </button>
  <button mat-menu-item class="h-8">
    <mat-icon class="icon-size-5 text-green-500" [svgIcon]="'heroicons_outline:at-symbol'"
      [matTooltip]="'Correo electrónico'" [matTooltipHideDelay]="500" [matTooltipPosition]="'left'"></mat-icon>
    <span class="text-base font-normal"> {{ user?.correo }}
    </span>
  </button>
  <button mat-menu-item class="h-8">
    <mat-icon class="icon-size-5 text-green-500" [svgIcon]="'heroicons_outline:clock'" [matTooltip]="'Último acceso'"
      [matTooltipHideDelay]="500" [matTooltipPosition]="'left'"></mat-icon>
    <span class="text-base font-normal">{{ user?.ultimaSesion }}
    </span>
  </button>
  <button mat-menu-item class="h-8" (click)="signOut()">
    <mat-icon class="icon-size-5 text-blue" [svgIcon]="'heroicons_outline:logout'"></mat-icon>
    <span class="text-base font-normal"> Cerrar sesión</span>
  </button>
</mat-menu>